import { render } from "./LoginResumeSession.vue?vue&type=template&id=6a56a479&scoped=true"
import script from "./LoginResumeSession.vue?vue&type=script&lang=js"
export * from "./LoginResumeSession.vue?vue&type=script&lang=js"

import "./LoginResumeSession.vue?vue&type=style&index=0&id=6a56a479&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a56a479"]])

export default __exports__